import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { RentalManagerUserInfoV2WebApiHandler_get } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { Client } from '@zg-rentals/http-client';
import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type User = RentalManagerAuthCheckUserInfoWebApiDto;

type AuthProviderProps = {
  client?: Client;
  pageWithSensitiveInformation?: boolean;
};

export const Auth = defineAuthProvider<AuthProviderProps, User>({
  queryOptions: ({ client, pageWithSensitiveInformation }) => ({
    refetchInterval: __DEV__ ? false : 3 * 60 * 1000,
    staleTime: 30 * 1000,
    retry: false,
    queryFn: () =>
      RentalManagerUserInfoV2WebApiHandler_get(
        {
          includeCanClaimFreeListings: true,
          includeCustomers: true,
          includeProfileImageUrl: true,
          pageWithSensitiveInformation,
        },
        client,
      ),
  }),

  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
